import axios from 'axios';

// axios.defaults.baseURL = 'https://cms.metatekvn.com';
// axios.defaults.baseURL = 'http://127.0.0.1:8000';
axios.defaults.baseURL = 'https://apisba.metatekvn.com';

export default axios;